/**
 * Marks the record operations that run long enough to need the header's activity indicator —
 * deleting, restoring and purging carry every attached file with them. BaseLayout counts only
 * mutations tagged with this key, so ordinary saves don't flash the indicator.
 */
export const RECORD_DELETE_RESTORE_MUTATION_KEY = ["record-delete-restore"];
